import {useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import {useAuth} from "../context/AuthContext";
import Spinner from "../components/Spinner";

interface ReponseConnexion {
    prenom: string;
    nom: string;
    email: string;
}

export default function Inscription() {
    const [prenom, setPrenom] = useState<string>("");
    const [nom, setNom] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [motDePasse, setMotDePasse] = useState<string>("");
    const [erreur, setErreur] = useState<string>("");
    const [chargement, setChargement] = useState<boolean>(false);

    const naviguer = useNavigate();
    const {seConnecter} = useAuth();

    const gererInscription = async (): Promise<void> => {
        if (!prenom || !nom || !email || !motDePasse) { setErreur("Veuillez remplir tous les champs"); return; }
        if (motDePasse.length < 6) { setErreur("Le mot de passe doit contenir au moins 6 caractères"); return; }
        setErreur("");
        setChargement(true);
        try {
            const reponse = await fetch(
                `${process.env.REACT_APP_API_URL}/api/auth/inscription`,
                {
                    method: "POST",
                    credentials: "include",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({prenom, nom, email, motDePasse})
                }
            );
            if (!reponse.ok) {
                let messageErreur = "Erreur lors de l'inscription";
                try { const donnees = await reponse.json(); if (donnees.message) messageErreur = donnees.message; } catch (e) {}
                setErreur(messageErreur);
                return;
            }
            const donnees: ReponseConnexion = await reponse.json();
            seConnecter(donnees.prenom, donnees.nom, donnees.email);
            naviguer("/tableau");
        } catch (e) {
            setErreur("Impossible de contacter le serveur");
        } finally {
            setChargement(false);
        }
    };

    const gererToucheEntree = (e: React.KeyboardEvent): void => {
        if (e.key === "Enter") gererInscription();
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center p-4 gap-6"
            style={{background: "linear-gradient(135deg, #6B21A8 0%, #9333EA 40%, #F97316 100%)"}}
            onKeyDown={gererToucheEntree}>
            <div className="absolute top-0 left-0 w-72 h-72 rounded-full opacity-20"
                style={{background: "radial-gradient(circle, #F97316, transparent)", transform: "translate(-30%, -30%)"}}/>
            <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full opacity-20"
                style={{background: "radial-gradient(circle, #6B21A8, transparent)", transform: "translate(30%, 30%)"}}/>
            <div className="text-center relative z-10">
                <h2 className="text-white text-3xl font-bold tracking-wide drop-shadow-lg">Rejoignez GMITIX</h2>
                <p className="text-white/70 text-sm mt-2">Simplifiez la gestion de vos réunions</p>
            </div>
            <div className="card w-full max-w-md bg-white shadow-2xl rounded-3xl relative z-10">
                <div className="card-body p-8">
                    <div className="flex justify-center mb-6">
                        <div className="px-8 py-3 rounded-2xl text-white font-bold text-2xl tracking-wide shadow-lg"
                            style={{background: "linear-gradient(90deg, #6B21A8, #F97316)"}}>GMITIX</div>
                    </div>
                    <p className="text-center text-gray-400 text-sm mb-6">Créez votre compte JuniorISEP</p>
                    {erreur && <div className="alert alert-error mb-4 rounded-xl"><span className="text-sm">{erreur}</span></div>}
                    <div className="grid grid-cols-2 gap-3 mb-3">
                        <div className="form-control">
                            <label className="label pb-1"><span className="label-text font-medium text-gray-700">Prénom</span></label>
                            <input type="text" placeholder="Prénom"
                                className="input input-bordered w-full rounded-xl border-2 focus:border-purple-500 focus:outline-none transition-all"
                                autoFocus value={prenom} onChange={(e) => setPrenom(e.target.value)} disabled={chargement}/>
                        </div>
                        <div className="form-control">
                            <label className="label pb-1"><span className="label-text font-medium text-gray-700">Nom</span></label>
                            <input type="text" placeholder="Nom"
                                className="input input-bordered w-full rounded-xl border-2 focus:border-purple-500 focus:outline-none transition-all"
                                value={nom} onChange={(e) => setNom(e.target.value)} disabled={chargement}/>
                        </div>
                    </div>
                    <div className="form-control mb-3">
                        <label className="label pb-1"><span className="label-text font-medium text-gray-700">Email</span></label>
                        <input type="email" placeholder="votre@email.com"
                            className="input input-bordered w-full rounded-xl border-2 focus:border-purple-500 focus:outline-none transition-all"
                            value={email} onChange={(e) => setEmail(e.target.value)} disabled={chargement}/>
                    </div>
                    <div className="form-control mb-6">
                        <label className="label pb-1"><span className="label-text font-medium text-gray-700">Mot de passe</span></label>
                        <input type="password" placeholder="••••••••"
                            className="input input-bordered w-full rounded-xl border-2 focus:border-purple-500 focus:outline-none transition-all"
                            value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} disabled={chargement}/>
                    </div>
                    <button className="w-full py-3 rounded-xl text-white font-semibold text-base transition-opacity hover:opacity-90 disabled:opacity-50 flex items-center justify-center"
                        style={{background: "linear-gradient(90deg, #6B21A8, #F97316)"}}
                        onClick={gererInscription} disabled={chargement}>
                        {chargement ? <Spinner size="sm"/> : "S'inscrire"}
                    </button>
                    <p className="text-center text-sm text-gray-400 mt-4">
                        Déjà un compte ?{" "}
                        <Link to="/connexion" className="font-semibold text-purple-600 hover:text-orange-500 transition-colors">Se connecter</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}